import React, { FC, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getAllPlans } from "../../../../store/reducers/servicePlansSlice";
import {
  getPlanClientAction,
  setNewClientLocal,
  updateTelnetSubscriptionAction,
} from "../../../../store/reducers/adminClientsSlice";
import FormField from "../../../../components/common/FormField";
import { subscriptionPlanFields } from "../clientAllFields";
import dayjs from "dayjs";
import moment from "moment";

interface ManageSubscriptionPlanProps {
  selectClient: any; // Adjust type as per your requirement
  formData?: any;
  setFormData?: any;
  action?: any;
}

const SubscriptionPlanForm: FC<ManageSubscriptionPlanProps> = ({
  selectClient,
  formData,
  setFormData,
  action
}) => {
  const { plans } = useSelector((state: any) => state.servicePlans);
  const { newClientLocal } = useSelector((state: any) => state?.adminClients);
  const [durationOptions, setDurationOptions] = useState([]);
  const [isChange, setIsChange] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllPlans());
    if(newClientLocal?.tenantId && action === 'plan'){
      dispatch(getPlanClientAction(newClientLocal?.tenantId));
    }
  }, [dispatch]);

  useEffect(() => {
    const selectedPlan = plans.find(
      (item: any) => item?.id === newClientLocal?.subscription?.planId
    );
    console.log("selectedPlan-", selectedPlan);
    const durationArray =
      selectedPlan && selectedPlan?.durations
        ? selectedPlan?.durations?.map((item: any) => ({
            id: item,
            label:
              item === "5D"
                ? "5 Days Trial"
                : item === "3M"
                  ? "3 Months"
                  : item === "6M"
                    ? "6 Months"
                    : item === "12M"
                      ? "12 Months"
                      : item,
          }))
        : [];
    setDurationOptions(durationArray);
    let obj = {}
    if(newClientLocal?.subscription?.duration && selectedPlan){
      console.log('selectedPlan-', selectedPlan)
    if(selectedPlan?.durations && selectedPlan?.durations.includes(newClientLocal?.subscription?.duration)) {
      console.log("if success")
      const selectedPlan = plans.find(
        (item: any) => item?.id === newClientLocal?.subscription?.planId
      );
      const totalConst:any = newClientLocal?.subscription?.duration === "5D" ? 0 : (selectedPlan?.price * parseInt(newClientLocal?.subscription?.duration))
      let cusStartDate = new Date().toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";
      if(newClientLocal?.subscription?.duration === "5D"){
        const dT = dayjs(cusStartDate).add(parseInt(newClientLocal?.subscription?.duration), "day");
        cusEndDate = (dT).format("MM/DD/YYYY")
        cusRenewsOn = (dayjs(dT).add(1, "day")).format("MM/DD/YYYY")
      }
      if(newClientLocal?.subscription?.duration === "3M" || newClientLocal?.subscription?.duration === "6M" || newClientLocal?.subscription?.duration === "12M"){
        const dT = dayjs(cusStartDate).add(parseInt(newClientLocal?.subscription?.duration), "month");
        cusEndDate = (dayjs(cusStartDate).add(parseInt(newClientLocal?.subscription?.duration), "month")).format("MM/DD/YYYY")
        cusRenewsOn = (dayjs(dT).add(1, "day")).format("MM/DD/YYYY")
      }
      obj = {
        subscriptionCost: totalConst,
        discount: newClientLocal?.subscription?.duration === "5D" ? 0 : !isChange ? newClientLocal?.subscription?.discount : selectedPlan?.discount,
        amountPayable: newClientLocal?.subscription?.duration === "5D" ? 0 : (selectedPlan?.discount && selectedPlan?.price) ? totalConst - (totalConst * (!isChange ? newClientLocal?.subscription?.discount : selectedPlan?.discount) / 100) : "",
        startDate: isChange ? cusStartDate : newClientLocal?.subscription?.startDate || "",
        endDate: isChange ? cusEndDate : newClientLocal?.subscription?.endDate || "",
        renewsOn: isChange ? cusRenewsOn : newClientLocal?.subscription?.renewsOn || ""
      }
    } else {
      console.log("if else")
      obj = {
        // duration: "",
        subscriptionCost: "",
        discount: "",
        amountPayable: "",
        term: "",
        startDate: "",
        endDate: "",
        renewsOn: ""
      }
    }
    dispatch(
      setNewClientLocal({
        // ...newClientLocal,
        subscription: {
          ...newClientLocal?.subscription,
          ...obj
        },
      })
    );
  }
  }, [plans, newClientLocal?.subscription?.planId]);

  // Extract plan names from the plans array
  const plansName = plans.map((item: any) => ({
    id: item?.id,
    label: item?.plan_name,
  }));

  // Update the subscription field to include plan options
  const updatedFields = subscriptionPlanFields.map((field) => {
    if (field.id === "planId") {
      return { ...field, options: plansName, type: "select" };
    }
    return field;
  });

  const handleFormValueChange = (field: string, value: any) => {
    console.log('value-', field, value)
    setIsChange(true)
    let obj = {}
    if(field === "duration") {
      const selectedPlan = plans.find(
        (item: any) => item?.id === newClientLocal?.subscription?.planId
      );
      const totalConst:any = value === "5D" ? 0 : (selectedPlan?.price * parseInt(value))
      let cusStartDate = new Date().toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";
      if(value === "5D"){
        const dT = dayjs(cusStartDate).add(parseInt(value), "day");
        cusEndDate = (dT).format("MM/DD/YYYY")
        cusRenewsOn = (dayjs(dT).add(1, "day")).format("MM/DD/YYYY")
      }
      if(value === "3M" || value === "6M" || value === "12M"){
        const dT = dayjs(cusStartDate).add(parseInt(value), "month");
        cusEndDate = (dayjs(cusStartDate).add(parseInt(value), "month")).format("MM/DD/YYYY")
        cusRenewsOn = (dayjs(dT).add(1, "day")).format("MM/DD/YYYY")
      }

      obj = {
        duration: value,
        subscriptionCost: totalConst,
        discount: value === "5D" ? 0 : selectedPlan?.discount,
        amountPayable: value === "5D" ? 0 : (selectedPlan?.discount && selectedPlan?.price) ? totalConst - (totalConst * selectedPlan?.discount / 100) : "",
        term: [dayjs(cusStartDate), dayjs(cusEndDate)],
        startDate: cusStartDate,
        endDate: cusEndDate,
        renewsOn: cusRenewsOn
      }
    }
    if(field === "discount") {
      const selectedPlan = plans.find(
        (item: any) => item?.id === newClientLocal?.subscription?.planId
      );
      const disValue = !value ? 0 : value
      const totalConst:any = newClientLocal?.subscription?.duration === "5D" ? 0 : (selectedPlan?.price * parseInt(newClientLocal?.subscription?.duration))
      obj = {
        discount: value,
        amountPayable: newClientLocal?.subscription?.duration === "5D" ? 0 : (disValue && selectedPlan?.price) ? totalConst - (totalConst * disValue / 100) : totalConst,
      }
    }
    if(field === "term") {
      let cusStartDate = new Date(value).toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";
      if(newClientLocal?.subscription['duration'] === "5D"){
        const dT = dayjs(cusStartDate).add(parseInt(newClientLocal?.subscription['duration']), "day");
        cusEndDate = (dT).format("MM/DD/YYYY")
        cusRenewsOn = (dayjs(dT).add(1, "day")).format("MM/DD/YYYY")
      }
      if(newClientLocal?.subscription['duration'] === "3M" || newClientLocal?.subscription['duration'] === "6M" || newClientLocal?.subscription['duration'] === "12M"){
        const dT = dayjs(cusStartDate).add(parseInt(newClientLocal?.subscription['duration']), "month");
        cusEndDate = (dT).format("MM/DD/YYYY")
        cusRenewsOn = (dayjs(dT).add(1, "day")).format("MM/DD/YYYY")
      }
      obj = {
        startDate: cusStartDate,
        endDate: cusEndDate,
        renewsOn: cusRenewsOn
        //renewsOn: value ? (dayjs(value).add(parseInt(newClientLocal?.subscription?.duration), "day")) : ""
      }
    }
    dispatch(
      setNewClientLocal({
        // ...newClientLocal,
        subscription: {
          ...newClientLocal?.subscription,
          [field]: value,
          // ...{ ...(field === "planId" && { duration: "" }) },
          ...obj
        },
      })
    );
    setFormData((prevValues: any) => ({ ...prevValues, [field]: value }));
  };

  return (
    <>
      {updatedFields.map(
        (field, i) =>
          !selectClient && (
            <Grid container spacing={2} key={i}>
              <FormField
                onPaste={(e)=>e.preventDefault()}
                onKeyDown={(event:any) => {
                  console.log('event log-',event, event.target.value + event.key)
                  if(
                    event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 37 ||
                    event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40 ||
                    event.keyCode === 18 || event.keyCode === 17 ||
                    event.ctrlKey
                  ) return event  
                  if(field?.patternAllowed && (!field?.patternAllowed.test(event.key))){
                    event.preventDefault();
                  } else if(field?.patternAllowed && (!field?.patternAllowed.test(event.target.value + event.key))){
                    event.preventDefault();
                  }
                }}
                {...{
                  ...field?.id === 'term' && {renewsOn: newClientLocal?.subscription['endDate']},
                  ...field,
                  value: newClientLocal?.subscription
                    ? field?.id === 'term' ? newClientLocal?.subscription['startDate'] : newClientLocal?.subscription[field?.id]
                    : "",
                  defaultValue: newClientLocal?.subscription
                    ? field?.id === 'term' ? newClientLocal?.subscription['startDate'] : newClientLocal?.subscription[field?.id]
                    : "",
                  ...{
                    ...(field?.id === "duration" && {
                      options: durationOptions,
                    }),
                  },
                }}
                InputProps={{
                  ...(newClientLocal?.subscription['duration'] === "5D" && field?.id === 'discount') && {disabled: true},
                  ...(newClientLocal?.subscription['duration'] === "" && field?.id === 'term') && {disabled: true},
                  ...(newClientLocal?.subscription['planId'] === "" && field?.id === 'duration') && {disabled: true},
                  sx:
                    field.type === "text" || field.type === "number"
                      ? { height: "36px" }
                      : { padding: "10px 4px", height: "36px" },
                }}
                selectedValues={formData[field.id]}
                onChange={(e: any) =>
                  handleFormValueChange(field.id, e.target.value)
                }
              />
            </Grid>
          )
      )}
    </>
  );
};

export default SubscriptionPlanForm;
